const SETTINGS_KEY = 'sbs_settings';

const defaults = {
  bench1RM: 0,
  squat1RM: 0,
  deadlift1RM: 0,
  benchProgram: null,
  squatProgram: null,
  deadliftProgram: null,
  setupComplete: false,
  rounding: 2.5,
  // Custom training day assignments: { bench: [0,2,4], squat: [0,2], deadlift: [4] }
  // Day indices: 0=Mon, 1=Tue, 2=Wed, 3=Thu, 4=Fri, 5=Sat, 6=Sun
  // null = use auto-assignment
  trainingDays: null,
  // Extra schedule items per day: { "0": ["Cardio"], "4": ["Accessories"] }
  scheduleExtras: {},
  // Per-lift notes shown on Home tab: { bench: "...", squat: "...", deadlift: "..." }
  liftNotes: {},
};

export function getSettings() {
  try {
    const stored = localStorage.getItem(SETTINGS_KEY);
    if (stored) {
      return { ...defaults, ...JSON.parse(stored) };
    }
  } catch (e) {
    console.error('Error reading settings:', e);
  }
  return { ...defaults };
}

export function saveSettings(updates) {
  const current = getSettings();
  const merged = { ...current, ...updates };
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(merged));
  return merged;
}

export function get1RM(lift) {
  const s = getSettings();
  return s[`${lift}1RM`] || 0;
}

export function set1RM(lift, value) {
  return saveSettings({ [`${lift}1RM`]: value });
}

export function getSelectedProgram(lift) {
  const s = getSettings();
  return s[`${lift}Program`];
}

export function setSelectedProgram(lift, programId) {
  return saveSettings({ [`${lift}Program`]: programId });
}
